import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { InvestService } from '@services/invest.service';
import { Invest } from '@classes/invest/invest';

@Component({
    selector: 'app-invest',
    templateUrl: './invest.component.html',
    styleUrls: ['./invest.component.scss']
})
export class InvestComponent implements OnInit {
    simuCode: string;

    constructor(
        private investSrv: InvestService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.initSubscriptions();
    }

    private initSubscriptions(): void {
        this.route.data
        .subscribe((data: { invest: Invest }) => {
            this.simuCode = data.invest ? data.invest.simulation.code : null;
            this.investSrv.investChanged.next(data.invest);
        });
    }
}
